/* Meglio summer 2026: nudge hand towels when couch roll goes in the basket.
   The 20% comes from the automatic discount "Couch Roll + Hand Towels", so there is no code.
   This file is loaded unconditionally from layout/theme.liquid. It must NOT be inlined into a
   snippet that only renders with a non-empty cart: the cart drawer morphs its markup and an
   inline script arriving that way never executes. Delete the script tag when the offer ends. */
(function () {
  'use strict';
  if (window.__megTowelUpsell) return;
  window.__megTowelUpsell = true;

  var ENDS = Date.parse('2026-08-23T22:59:59Z');
  var COUCH = [7206983336097, 8013644955809, 8040235401377, 8133042274465];
  var TOWEL_PRODUCT = 15651405758845;
  var TOWEL_VARIANT = 57330327454077;           /* V fold, pack of 3000 */
  var TOWEL_URL = '/products/paper-hand-rolls';
  var IMG = 'https://cdn.shopify.com/s/files/1/1343/4847/files/7_44d05799-1701-449b-a08e-7fa768b8977d.jpg?v=1769504724&width=320';
  var WAS = '£23.45', NOW = '£18.76', NOW_EX = '£15.63';
  var KEY = 'meg-towel-upsell-done';
  var busy = false, open = false, lastFocus = null;

  function expired() { return isNaN(ENDS) || Date.now() > ENDS; }
  function seen() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }

  function css() {
    if (document.getElementById('meg-tu-css')) return;
    var s = document.createElement('style');
    s.id = 'meg-tu-css';
    s.textContent = [
      '.meg-tu-back,.meg-tu-back *{box-sizing:border-box}',
      '.meg-tu-back{position:fixed;inset:0;background:rgba(24,14,44,.55);z-index:2147483000;opacity:0;transition:opacity .18s ease;display:flex;align-items:center;justify-content:center;padding:20px}',
      '.meg-tu-back.on{opacity:1}',
      '.meg-tu{background:#fff;border-radius:14px;max-width:430px;width:100%;box-shadow:0 24px 60px rgba(20,10,40,.34);overflow:hidden;transform:translateY(10px);transition:transform .18s ease;font-family:"DM Sans","Helvetica Neue",Helvetica,Arial,sans-serif}',
      '.meg-tu-back.on .meg-tu{transform:none}',
      '.meg-tu-top{height:4px;background:#472175}',
      '.meg-tu-in{padding:22px 24px 24px}',
      '.meg-tu h2{margin:0 0 8px;font-size:20px;line-height:1.25;color:#1A1730;font-weight:700;letter-spacing:-.01em}',
      '.meg-tu p{margin:0 0 16px;font-size:14.5px;line-height:1.55;color:#3F3956}',
      '.meg-tu-item{display:flex;gap:14px;align-items:center;border:1px solid #E9E4F1;border-radius:10px;padding:12px;margin:0 0 18px}',
      '.meg-tu-item img{width:66px;height:66px;object-fit:contain;background:#F8F6F1;border-radius:6px;flex:0 0 66px}',
      '.meg-tu-item>div{min-width:0;flex:1 1 auto}',
      '.meg-tu-nm{font-size:14.5px;font-weight:700;color:#1A1730;line-height:1.3}',
      '.meg-tu-sz{font-size:12.5px;color:#8A8398;margin-top:2px}',
      '.meg-tu-pr{margin-top:6px;font-size:13px;color:#8A8398;line-height:1.5}',
      '.meg-tu-pr s{color:#A9A3B6}',
      '.meg-tu-pr b{color:#0E7A6B;font-size:16px;margin-left:4px}',
      '.meg-tu-btn{display:block;width:100%;border:0;border-radius:6px;background:#472175;color:#fff;font-size:15.5px;font-weight:700;padding:14px 16px;cursor:pointer;font-family:inherit;line-height:1.2}',
      '.meg-tu-btn:hover{background:#37185c}',
      '.meg-tu-btn[disabled]{opacity:.6;cursor:default}',
      '.meg-tu-no{display:block;width:100%;margin-top:10px;border:0;background:none;color:#8A8398;font-size:13.5px;padding:8px;cursor:pointer;font-family:inherit;text-decoration:underline}',
      '.meg-tu-x{position:absolute;top:10px;right:12px;border:0;background:none;font-size:24px;line-height:1;color:#8A8398;cursor:pointer;padding:4px 8px;font-family:inherit}',
      '.meg-tu-wrap{position:relative}',
      '@media(max-width:520px){.meg-tu-back{align-items:flex-end;padding:0}.meg-tu{max-width:100%;border-radius:14px 14px 0 0}}'
    ].join('');
    document.head.appendChild(s);
  }

  function close() {
    var b = document.querySelector('.meg-tu-back');
    if (!b) return;
    open = false;
    b.classList.remove('on');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 200);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function add(btn) {
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: TOWEL_VARIANT, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      markSeen();
      btn.textContent = 'Added, 20% comes off at checkout';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      setTimeout(function () {
        close();
        if (location.pathname.indexOf('/cart') === 0) location.reload();
      }, 900);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Add a box, 20% off';
      window.location = TOWEL_URL;
    });
  }

  function show() {
    if (open || seen() || expired()) return;
    css();
    open = true;
    lastFocus = document.activeElement;
    var back = document.createElement('div');
    back.className = 'meg-tu-back';
    back.setAttribute('role', 'dialog');
    back.setAttribute('aria-modal', 'true');
    back.setAttribute('aria-label', 'Add hand towels and save 20 percent');
    back.innerHTML =
      '<div class="meg-tu"><div class="meg-tu-top"></div><div class="meg-tu-wrap">' +
      '<button class="meg-tu-x" type="button" aria-label="Close">&times;</button>' +
      '<div class="meg-tu-in">' +
      '<h2>Add hand towels and save 20%</h2>' +
      '<p>You have couch roll in the basket, so a box of hand towels comes with 20% off. There is no code, it comes off at checkout.</p>' +
      '<div class="meg-tu-item">' +
      '<img src="' + IMG + '" alt="Meglio hand paper towels, pack of 3000, V fold" width="66" height="66">' +
      '<div><div class="meg-tu-nm">Hand Towels, V Fold</div>' +
      '<div class="meg-tu-sz">Pack of 3000, interfold</div>' +
      '<div class="meg-tu-pr"><s>' + WAS + '</s><b>' + NOW + '</b> inc VAT &middot; ' + NOW_EX + ' ex VAT</div></div>' +
      '</div>' +
      '<button class="meg-tu-btn" type="button">Add a box, 20% off</button>' +
      '<button class="meg-tu-no" type="button">No thanks, carry on shopping</button>' +
      '</div></div></div>';
    document.body.appendChild(back);
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { back.classList.add('on'); });
    setTimeout(function () { back.classList.add('on'); }, 40); /* rAF is throttled in background tabs */

    var addBtn = back.querySelector('.meg-tu-btn');
    addBtn.addEventListener('click', function () { add(addBtn); });
    back.querySelector('.meg-tu-no').addEventListener('click', function () { markSeen(); close(); });
    back.querySelector('.meg-tu-x').addEventListener('click', function () { markSeen(); close(); });
    back.addEventListener('click', function (e) { if (e.target === back) { markSeen(); close(); } });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { markSeen(); close(); document.removeEventListener('keydown', esc); }
    });
    setTimeout(function () { addBtn.focus(); }, 60);
  }

  function check() {
    if (busy || open || seen() || expired()) return;
    if (location.pathname.indexOf('/checkout') === 0) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasCouch = false, hasTowel = false;
        (cart.items || []).forEach(function (it) {
          if (COUCH.indexOf(it.product_id) !== -1) hasCouch = true;
          if (it.product_id === TOWEL_PRODUCT) hasTowel = true;
        });
        busy = false;
        if (hasCouch && !hasTowel) show();
      })
      .catch(function () { busy = false; });
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) {
      p.then(function () { setTimeout(check, 500); });
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) {
      this.addEventListener('load', function () { setTimeout(check, 500); });
    }
    return origOpen.apply(this, arguments);
  };

  /* also cover full page loads that land on the cart with couch roll already in it */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(check, 900); });
  } else {
    setTimeout(check, 900);
  }
})();
